import { Badge } from "@mantine/core";
import { useTranslation } from "react-i18next";

import { getColorFromTransitionStatus } from "@/utils/getColorFromTransitionStatus";

import type { AuctionCarTransaction } from "@/types/auctions";
import type { BadgeProps, BoxProps, MantineSize, MantineStyleProps } from "@mantine/core";
import type { FC } from "react";

export type TransactionStatusBadgeProps = {
  size?: MantineSize;
  status?: AuctionCarTransaction["status"] | AuctionCarTransaction["result"];
} & MantineStyleProps &
  Pick<BoxProps, "hiddenFrom" | "visibleFrom">;

export const TransactionStatusBadge: FC<TransactionStatusBadgeProps> = ({
  size,
  status,
  ...props
}) => {
  const { t } = useTranslation();

  function getBadgePropsFromStatus(
    status?: AuctionCarTransaction["status"] | AuctionCarTransaction["result"]
  ) {
    switch (status) {
      case "not_sold":
      case "sold_at_auction":
      case "sold":
      case "unknown":
        return { variant: `light-${getColorFromTransitionStatus(status)}` } as BadgeProps;
      default:
        return { variant: "light" } as BadgeProps;
    }
  }

  return (
    status && (
      <Badge {...getBadgePropsFromStatus(status)} size={size} tt="uppercase" {...props}>
        {t(`components.TransactionTableRow.result.${status}`, status)}
      </Badge>
    )
  );
};
